module.exports = __webpack_public_path__ + "static/media/RoaDo.2a2469fb.webp";